import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { EmptyState, ErrorMessage, LoadingGrid } from '../components/LoadingGrid';
import { api } from '../lib/api-client';
import { useCurrentUser } from '../lib/hooks';

/**
 * Daftar Favorit user. ID Telegram terdeteksi otomatis dari initData
 * (header Authorization: tma <initData>) — tidak perlu login manual.
 * Kalau dibuka di browser biasa (bukan Telegram), tampilkan ajakan buka
 * lewat bot.
 */
export function FavoritesPage() {
  const meQuery = useCurrentUser();
  const me = meQuery.data?.user ?? null;

  const favQuery = useQuery({
    queryKey: ['favorites'],
    queryFn: () => api.favorites(),
    enabled: me !== null,
  });

  return (
    <div className="mx-auto max-w-6xl px-4 pb-8 safe-top">
      <header className="py-3">
        <h1 className="font-display text-2xl font-extrabold">Favorit</h1>
      </header>

      {me === null ? (
        <EmptyState message="Buka aplikasi lewat Telegram (@DongNime_Bot) untuk menyimpan & melihat favorit." />
      ) : favQuery.isPending ? (
        <LoadingGrid />
      ) : favQuery.isError ? (
        <ErrorMessage
          title="Gagal memuat favorit"
          message={favQuery.error.message}
          onRetry={() => void favQuery.refetch()}
        />
      ) : favQuery.data.items.length === 0 ? (
        <EmptyState message="Belum ada favorit. Tekan tombol Daftar Saya di halaman detail drama." />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {favQuery.data.items.map((f) => (
            <Link
              key={f.id}
              to={`/drama/${f.platform}/${f.externalDramaId}`}
              className="group block"
            >
              <div className="relative aspect-poster overflow-hidden rounded-lg bg-neutral-800">
                {f.poster ? (
                  <img
                    src={f.poster}
                    alt=""
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform group-hover:scale-105"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = 'none';
                    }}
                  />
                ) : (
                  <div className="grid h-full w-full place-items-center bg-gradient-to-br from-neutral-800 to-neutral-900 text-xs text-neutral-500">
                    {f.title.slice(0, 2)}
                  </div>
                )}
                <span className="absolute bottom-1.5 left-1.5 rounded bg-black/60 px-1.5 py-0.5 text-[10px] uppercase text-white backdrop-blur">
                  {f.platform}
                </span>
              </div>
              <h3 className="mt-2 line-clamp-2 text-sm font-medium leading-tight">
                {f.title}
              </h3>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
